import type {ReactElement} from 'react';

export interface TransitionablePanelV2Props {
  panelId: string;
  content: ReactElement | null;
  header: ReactElement<any> | null;
  contentKey: string;
  transitionDirection: TransitionDirection;
  imageURL?: string;
  imageAlt?: string;
  videoURL?: string;
  modalId?: string;
  loadingText?: string;
  isLoading?: boolean;
  isCloseIconDisabled?: boolean;
  hideCloseIcon?: boolean;
  isScrollable?: boolean;
  closeIconClassName?: string;
  hideSeeMorePill?: boolean;
  onModalClose?: () => void;
}

export enum TransitionDirection {
  FORWARD = 'forward',
  BACKWARD = 'backward',
}
